import { FC } from "react";

interface SortArrowsIconSVGProps {
    className?: string;
}

const SortArrowsIconSVG: FC<SortArrowsIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 13L5 17M5 17L9 13M5 17V1M19 5L15 1M15 1L11 5M15 1L15 17"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SortArrowsIconSVG;
